module.exports = __webpack_public_path__ + "static/media/canvas-logo.bbbf1cc8.png";